<template>
  <slotted-edit-list-item :label="label"
                          :keyname="keyname"
                          :value="value"
                          :edit="edit"
                          :valuecolor="valuecolor"
                          :noempty="noempty"
                          :charlimit="charlimit"
                          :email="email"
                          :tlf="tlf"
                          :suffix="suffix"
                          :onlyedit="onlyedit"
                          :clickedit="clickedit"
                          :compact="compact"
                          :loading="loading"
                          :searchterm="searchterm"
                          @fetch="passfetch"
                          @finalval="passfinalval">
  </slotted-edit-list-item>
</template>



<script>
import SlottedEditListItem from "@/components/Inputs/Parts/SlottedEditListItem.vue";

export default {
  name: "EditListItem",
  /*model: {
    prop: "value",
    event: "change",
  },*/
  props: [
    "label",
    "keyname",
    "value",
    "edit",
    "valuecolor",
    "noempty",
    "charlimit",
    "email",
    "tlf",
    "onlyedit",
    "clickedit",
    "compact",
    "suffix",
    "loading",
    "searchterm",
  ],
  components: { SlottedEditListItem },

  data() {
    return {};
  },

  mounted() {},

  methods: {
    passfetch(update) {
      this.$emit("fetch", update);
      this.$emit("change", update.value);
      this.$emit("input", update.value);
    },
    passfinalval(val) {
      this.$emit("finalval", val);
    },
  },

  computed: {},

  watch: {},
};
</script>
